import React, { useEffect } from 'react';
import { useComprehensiveAnalytics } from '../../hooks/useAnalytics';
import { startPerformanceMonitoring } from '../../services/performanceService';
import { logger } from '../../utils/logger';

/**
 * Analytics Manager Component
 * 
 * Handles initialization and management of all analytics services
 * - Firebase Analytics
 * - Performance Monitoring  
 * - Web Vitals tracking
 * - Automatic event tracking
 * 
 * This component should be placed near the top of the component tree
 * to ensure analytics are initialized early and tracking works properly
 */
const AnalyticsManager: React.FC = () => {
  const analytics = useComprehensiveAnalytics();

  useEffect(() => {
    // Initialize performance monitoring
    if (analytics.isAnalyticsEnabled) {
      try {
        startPerformanceMonitoring();
        logger.success('🚀 Analytics and Performance Monitoring fully initialized');
      } catch (error) {
        logger.error('❌ Error initializing performance monitoring:', error);
      }
    }
  }, [analytics.isAnalyticsEnabled]);

  // This component doesn't render anything visible
  return null;
};

export default AnalyticsManager;
